import {BasePopupProps} from "@utils/Models";
import {GUID} from "@utils/AppConstants";
import {OrderRecipePreviewModel} from "@pages/orders/order.models";
import OrderRecipeEditPanel from "@pages/orders/preview/recipes/edit/OrderRecipeEditPanel";

export default function OrderRecipeEditPopup(props: OrderRecipeEditPopupProps) {
    const {handlers} = useOrderRecipeEditPopup(props);
    return <OrderRecipeEditPanel {...props}
                                 OnCancelClicked={handlers.handleCancelClicked}
                                 OnRecipeSaved={handlers.handleSavedClicked}/>
}

export interface OrderRecipeEditPopupProps extends BasePopupProps<OrderRecipePreviewModel> {
    OrderGuid: GUID;
    ColourStandardGuid: GUID;
    RecipeGuid?: GUID;
    CanAddComponents?: boolean;
    SeriesId?: number;
    SubstrateId?: number;
    ColourStandardName?: string;
}

function useOrderRecipeEditPopup(props: OrderRecipeEditPopupProps) {
    function handleSavedClicked(recipe:OrderRecipePreviewModel) {
        props.OnConfirmedAndSaved(recipe);
    }
    function handleCancelClicked(){
        props.OnCancelled();
    }
    return {
        handlers:{
            handleSavedClicked,
            handleCancelClicked,
        }
    }
}